import { DataValidationError } from "constants/DataValidationError";
import {
  IsArray,
  IsDecimal,
  IsEmail,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
} from "class-validator";
import Spec from "constants/Spec";
import { Type } from "class-transformer";

export default class UpdateCastReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  readonly castId: number;

  @MaxLength(Spec.maxLength.cast.email, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.email,
    },
  })
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  @IsEmail(
    {},
    {
      message: DataValidationError.DATA_IS_INVALID,
    }
  )
  email!: string;

  @MaxLength(Spec.maxLength.cast.name, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.name,
    },
  })
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  name!: string;

  @MaxLength(Spec.maxLength.cast.displayName, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.displayName,
    },
  })
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  displayName!: string;

  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  castCategoryId!: number;

  @IsOptional()
  @MaxLength(Spec.maxLength.cast.password, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.password,
    },
  })
  password: string | null = null;

  @MaxLength(Spec.maxLength.cast.tel, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.tel,
    },
  })
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  tel!: string;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @MaxLength(Spec.maxLength.cast.address, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.address,
    },
  })
  address!: string;

  @IsOptional()
  @MaxLength(Spec.maxLength.cast.remarks, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.remarks,
    },
  })
  remarks!: string;

  @IsArray()
  shops!: number[];

  @IsOptional()
  @IsArray()
  ngAreas!: number[];

  @IsOptional()
  @IsArray()
  ngGuests!: string[];

  @IsOptional()
  @IsNumber()
  sort!: number | null;

  @IsOptional()
  @Type(() => Date)
  entryDate: Date | null = null;

  @IsOptional()
  @Type(() => Date)
  closingDate: Date | null = null;

  @IsOptional()
  invoiceRate!: number | null;

  @IsOptional()
  @IsNumber()
  recruitingMediaId!: number | null;

  @IsOptional()
  lineUserId?: string | null;

  @IsOptional()
  notifyMethod?: string;

  constructor(arg: any) {
    arg = arg || {};
    this.castId = arg.castId;
    this.name = arg.name;
    this.castCategoryId = arg.castCategoryId;
    this.displayName = arg.displayName;
    this.password = arg.password;
    this.email = arg.email;
    this.tel = arg.tel;
    this.shops = arg.shops;
    this.ngAreas = arg.ngAreas;
    this.ngGuests = arg.ngGuests;
    this.address = arg.address;
    this.remarks = arg.remarks;
    this.sort = arg.sort;
    this.entryDate = arg.entryDate;
    this.closingDate = arg.closingDate;
    this.invoiceRate = arg.invoiceRate;
    this.recruitingMediaId = arg.recruitingMediaId;
    this.lineUserId = arg.lineUserId;
    this.notifyMethod = arg.notifyMethod;
  }
}
